const $ = require('jquery');

export function blocks() {
 
    (function(){

        const accordionBlock = function() { 
		
            jQuery('.accordion-wrapper').each(function() {

                const accordion = jQuery(this).attr('id'); 
                const defaultImg = jQuery(this).find('.accordion-image').html();

                jQuery('#'+accordion+' .accordion > dd').hide();

                jQuery('#'+accordion+' .accordion > dt > a').click(function() {
                    if ( jQuery(this).parent('dt').hasClass('active')) {
                        jQuery('dt.active').removeClass('active');
                        jQuery('#'+accordion+' .accordion > dd').slideUp();
                        jQuery('.accordion-image').html(defaultImg);
                    } else {
                        const currentImg = jQuery(this).parents('dt').next('dd').find('.accordion-item-image').html();
                        jQuery('dt.active').removeClass('active');
                        jQuery(this).parent('dt').addClass('active');
                        jQuery('#'+accordion+' .accordion > dd').slideUp();
                        jQuery(this).parent().next().slideDown();
                        jQuery('.accordion-image').html(currentImg);
                        console.log(currentImg);
                        return false;
                    }
                }); 

            }); 
			
        }

        const archivePostSlider = function() { 
	        $('.archive__slider-post').not('.slick-initialized').slick({
                rows: 1,
                infinite: true,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                swipeToSlide: true,
                autoplay: false,
                adaptiveHeight: true,
                fade: true,
                cssEase: 'linear',
                appendArrows: '.slick-slide .featured-post__content .slider-nav',
            });
        
            $('.archive__slider-post .slider-nav .slick-prev').on('click', function(){
                $('.archive__slider-post').slick("slickPrev");
            });
            $('.archive__slider-post .slider-nav .slick-next').on('click', function(){
                $('.archive__slider-post').slick("slickNext");
            });
        }

        const calloutSliderText = function() { 
	        $('[data-js="callout-slider-text"]').not('.slick-initialized').slick({
                dots: false,
                fade: true,
                speed: 500,
                rows: 0,
                adaptiveHeight: true,
                appendArrows: $('[data-js="callout-slider-nav"]'),
                asNavFor: '[data-js="callout-slider-media"]',
            }); 
        }

        const calloutSliderMedia = function() { 
	        $('[data-js="callout-slider-media"]').not('.slick-initialized').slick({
                dots: false,
                arrows: false,
                infinite: true,
                speed: 500,
                slidesToShow: 3,
                //slidesToScroll: 1,
                centerMode: true,
                centerPadding: '0px',
                rows: 0,
                asNavFor: '[data-js="callout-slider-text"]',
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerPadding: '20%',
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
			   ]
            }); 
        }

        const gallerySlider = function() { 
	        
	        $('.image-gallery-slider').each(function() {
		        
		       const sliderID = $(this).parents('.block-wrapper').attr('id');
	            
		        $(this).not('.slick-initialized').slick({
			        rows: 0,
	                dots: false,
	                infinite: true,
	                speed: 500,
	                slidesToShow: 1,
	                slidesToScroll: 1,
	                centerMode: true,
	                centerPadding: '25%',
	                appendArrows: '#'+sliderID+' .image-gallery-slider-nav',
	                responsive: [
                        {
                            breakpoint: 1024,
                            settings: {
                                centerPadding: '10%',
                            }
                        },
                    ]
	            });  
            
            });
            
        }

        const mediaSliderText = function() { 
	        $('[data-js="media-slider-text"]').not('.slick-initialized').slick({
                dots: false,
                fade: true,
                speed: 500,
                rows: 0,
                adaptiveHeight: true,
                appendArrows: $('[data-js="media-slider-nav"]'),
                asNavFor: '[data-js="media-slider-media"]',
            }); 
        }

        const mediaSliderMedia = function() { 
	        $('[data-js="media-slider-media"]').not('.slick-initialized').slick({
                dots: false,
                arrows: false,
                fade: true,
                speed: 500,
                rows: 0,
                asNavFor: '[data-js="media-slider-text"]',
            }); 
        }

        const newsSlider = function() { 
	        $('.archive__slider-news').not('.slick-initialized').slick({
                arrows: false,
                rows: 0,
                infinite: true,
                dots: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                swipe: true,
                swipeToSlide: true,
                autoplay: false,
                adaptiveHeight: false,
                fade: true,
                cssEase: 'linear',
                asNavFor: '.slider-news-nav',
                responsive: [   
                    {
                        breakpoint: 768,
                        settings: {
                            adaptiveHeight: true,
                        },
                    },
                ]
            });
            $('.featured-news__content .slider-nav .slick-prev').on('click', function(){
                $('.archive__slider-news').slick("slickPrev");
            });
            $('.featured-news__content .slider-nav .slick-next').on('click', function(){
                $('.archive__slider-news').slick("slickNext");
            });

            $('.slider-news-nav').not('.slick-initialized').slick({
                rows: 0,
                arrows: true,
                vertical: true,
                verticalSwiping: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                focusOnSelect: true,
                asNavFor: '.archive__slider-news',
                appendArrows: '.archive__slider-news-nav .slider-nav',
            });

        }

        const postSlider = function() { 
	        $('[data-js="post-slider"]').not('.slick-initialized').slick({
                dots: false,
                arrows: true,
                speed: 500,
                slidesToShow: 2,
                centerMode: false,
                rows: 0,
                focusOnSelect: true,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 576,    
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: false,  
                        } ,
                    },
			   ]
            }); 
        }


        const testimonialSlider = function() { 
	        $('[data-js="testimonial-slider"]').not('.slick-initialized').slick({
                dots: false,
                arrows: true,
                speed: 500,
                slidesToShow: 3,
                centerMode: true,
                centerPadding: '0px',
                rows: 0,
                focusOnSelect: true,
                appendArrows: $('[data-js="testimonial-slider-nav"]'),
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 576,    
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerMode: false,  
                        } ,
                    },
			   ]
            }); 
        }
	
	    // Initialize each block on page load (front end).
	    $(document).ready(function(){
            accordionBlock();
            archivePostSlider();
            calloutSliderText();
            calloutSliderMedia();
            gallerySlider();
            mediaSliderText();
            mediaSliderMedia();
            postSlider();
            newsSlider();
            testimonialSlider();
	    });
	
	    // Initialize dynamic block preview (editor).
	    if( window.acf ) {
            window.acf.addAction( 'render_block_preview/type=accordion', accordionBlock );
            window.acf.addAction( 'render_block_preview/type=page-header', archivePostSlider );
            window.acf.addAction( 'render_block_preview/type=callout-slider', calloutSliderText );
            window.acf.addAction( 'render_block_preview/type=callout-slider', calloutSliderMedia );
            window.acf.addAction( 'render_block_preview/type=image-slider', gallerySlider );
            window.acf.addAction( 'render_block_preview/type=media-content', mediaSliderText );
            window.acf.addAction( 'render_block_preview/type=media-content', mediaSliderMedia );
            window.acf.addAction( 'render_block_preview/type=page-header', newsSlider );
            window.acf.addAction( 'render_block_preview/type=post-slider', postSlider );
            window.acf.addAction( 'render_block_preview/type=testimonials', testimonialSlider );
	    }
	
    })(jQuery);
    
}